/**
 * Метод проверяет переданный параметр, и возвращает его же, если он является истинным
 * в противном случае будет возвращенно значение undefined
 *
 * @param names - массив с именами файлов, или строка с именем
 * @returns переданное значение, или undefined
 */
export const getFileNames = (names: string | string[]): string | string[] | undefined => {
  if (Array.isArray(names)) {
    return !!names.length ? names : undefined;
  }

  return names || undefined;
};
